import React from "react";

export const PriceColumnFormatter = (cellContent, row) => {
  const value =
    cellContent !== undefined && cellContent !== null && cellContent !== ""
      ? cellContent
      : row && (row.price !== undefined && row.price !== null ? row.price : row.credit !== undefined && row.credit !== null ? row.credit : 0);

  if (value === undefined || value === null || value === "") {
    return <>0 ریال</>;
  }

  const parts = value.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const formattedPrice = parts.join(".");

  return <>{formattedPrice} ریال</>;
};
